const EVENT_CONFIG = Object.freeze({
  signup_complete: { google: 'sign_up', meta: 'CompleteRegistration' },
  game_created: { google: 'game_created', meta: 'GameCreated' },
  game_published: { google: 'game_published', meta: 'GamePublished' },
})

const REPORTED_KEY = 'tinker:reported-ad-conversions'
const MAX_REPORTED_IDS = 100

function reportedIds() {
  try {
    const value = JSON.parse(window.sessionStorage.getItem(REPORTED_KEY) || '[]')
    return Array.isArray(value) ? value : []
  } catch {
    return []
  }
}

function remember(id) {
  if (!id) return
  try {
    const ids = [...new Set([...reportedIds(), id])].slice(-MAX_REPORTED_IDS)
    window.sessionStorage.setItem(REPORTED_KEY, JSON.stringify(ids))
  } catch { /* Analytics must never interrupt the product flow. */ }
}

function configuredSendTo(name) {
  return document.querySelector(`meta[name="google-ads-${name.replaceAll('_', '-')}-conversion"]`)?.content || ''
}

// GrowthEvent is the durable funnel ledger. This is only the browser handoff to the
// ad platforms, and intentionally contains no phone, email, username, or prompt text.
export function reportAdConversion(conversion) {
  if (typeof window === 'undefined' || document.querySelector('meta[name="site-realm"]')?.content === 'kids') return
  const config = EVENT_CONFIG[conversion?.name]
  if (!config) return
  const id = conversion.id || `${conversion.name}:${conversion.game_public_id || 'account'}`
  if (reportedIds().includes(id)) return
  remember(id)

  const parameters = {
    event_id: id,
    conversion_name: conversion.name,
    ...(conversion.game_public_id ? { game_public_id: conversion.game_public_id } : {}),
  }

  try { window.dataLayer?.push({ event: 'tinker_conversion', ...parameters }) } catch { /* best effort */ }
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', config.google, parameters)
      const sendTo = configuredSendTo(conversion.name)
      if (sendTo) window.gtag('event', 'conversion', { ...parameters, send_to: sendTo })
    }
  } catch { /* best effort */ }
  try {
    if (typeof window.fbq === 'function') {
      if (conversion.name === 'signup_complete') window.fbq('track', config.meta, parameters, { eventID: id })
      else window.fbq('trackCustom', config.meta, parameters, { eventID: id })
    }
  } catch { /* best effort */ }
  try {
    const xEventId = document.querySelector(`meta[name="x-ads-${conversion.name.replaceAll('_', '-')}-event"]`)?.content
    if (xEventId && typeof window.twq === 'function') window.twq('event', xEventId, parameters)
  } catch { /* best effort */ }
}

export function reportAdConversions(conversions = []) {
  conversions.forEach(reportAdConversion)
}
